<script lang="ts">
  import type { SpotPriser } from "$lib/types/spotPriser";
  import AreaSelect from "./AreasSelect.svelte";
  import { selectAreas } from "$lib/utils/areaUtils";
  import { getDaysData, getMaxPrice, type DayData } from "./daysData";
  import SpotPriceDaysChart from "./SpotPriceDaysChart.svelte";
  // import SpotPriceDaysTable from "./SpotPriceDaysTable.svelte";
  import { localeRound as round } from "$lib/utils/math";
  import { theTime } from "$lib/utils/the-time";

  let {
    spotPriser = [],
  }: {
    spotPriser: SpotPriser[];
  } = $props();

  let selectedAreas = $state(selectAreas.map((x) => x.urlLabel));
  let selectedAreaObjects = $derived(selectAreas.filter((x) => selectedAreas.includes(x.urlLabel)));
  let daysData: Map<string, DayData> | undefined = $derived.by(() => {
    if (!spotPriser?.length) return;
    else
      return getDaysData(
        spotPriser,
        selectAreas.filter((x) => selectedAreas.includes(x.urlLabel)).map((x) => x.value)
      );
  });
  let maxY = $derived.by(() => {
    const maxPrice = !spotPriser ? 0 : getMaxPrice(spotPriser);
    return maxPrice + maxPrice * 0.1;
  });
  let selectedDay: undefined | string = $state(theTime().toPlainDateString());
  let selectedPrices = $derived.by(() => {
    // eslint-disable-next-line svelte/prefer-svelte-reactivity
    let prices = new Map();

    if (selectedDay) {
      spotPriser.forEach((x) => {
        x.dager.forEach((y) => {
          if (y.dato === selectedDay) {
            // prices.push(y.dognpris);
            prices.set(x.omrade, round(y.dognpris));
          }
        });
      });
    }

    return prices;
  });
</script>

<SpotPriceDaysChart {daysData} selectedAreas={selectedAreaObjects} {maxY} bind:selectedDay>
  <AreaSelect
    class="flex justify-center gap-x-2 mt-0 pt-2"
    bind:selectedAreas
    useAreaColors
    {selectedPrices}
  />
</SpotPriceDaysChart>
